export default "__VITE_ASSET__CcQa9JCU__"